<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import { WhatsappButtonClass } from '#lib/constants/whatsapp.js';
	import { ChevronRightIcon } from '$global/assets/icons/ChevronRightIcon';
	import { WhatsappIcon } from '$global/assets/icons/WhatsappIcon';
	import { Link } from '$global/components/Link';
	import { LinkButton } from '$global/components/LinkButton';
	import { Tooltip } from '$global/components/Tooltip';
	import { Txt } from '$global/components/Txt';
	import { NEWSLETTER_WHATSAPP_LINK } from '$global/features/newsletter-generation/constants/whatsapp';

	interface Props {
		dataCy: string;
	}

	let { dataCy }: Props = $props();

	let dataCyPrefix = $derived(`${dataCy}-whatsapp`);
</script>

{#snippet whatsappIcon()}
	<WhatsappIcon color="gray-0" />
{/snippet}

{#snippet card()}
	<div
		class="bg-gray-0 relative w-[16rem] rounded border border-gray-200 p-5 text-left shadow-lg"
	>
		<div
			class="bg-gray-0 absolute -top-[0.4375rem] left-1/2 h-3 w-3 -translate-x-1/2 rotate-45 border-t border-l border-gray-200"
		></div>
		<Txt variant="h6" component="p">Talk to HENI News</Txt>
		<Txt variant="body2" class="mt-1">
			Have a story tip, feedback, a correction or a question?
		</Txt>
		<Link
			href={NEWSLETTER_WHATSAPP_LINK}
			target="_blank"
			rel="noopener noreferrer"
			dataCy={`${dataCyPrefix}-open`}
			class="mt-4 flex items-center gap-2 border-t border-gray-200 pt-4"
		>
			<Txt component="span" variant="label3" class="text-[#18D842]">
				Open WhatsApp
			</Txt>
			<ChevronRightIcon class="h-3 w-3 [&>path]:fill-[#18D842]" />
		</Link>
	</div>
{/snippet}

<!--
	The card is padded (not margined) away from the button so the pointer stays
	inside the Tooltip's hover area on its way down to "Open WhatsApp".
	tabIndex -1: the button inside is already the keyboard stop.
-->
<Tooltip
	dataCy={dataCyPrefix}
	placement="bottom"
	tabIndex={-1}
	contentSlot={card}
	class="cursor-auto"
	classes={{ content: 'mt-0 max-w-none bg-transparent p-0 pt-3' }}
>
	<LinkButton
		dataCy={dataCyPrefix}
		href={NEWSLETTER_WHATSAPP_LINK}
		newTab
		size="sm"
		variant="secondary"
		icon
		leading={whatsappIcon}
		buttonProps={{
			class: twMerge(WhatsappButtonClass, 'cursor-pointer'),
			classes: { label: 'text-gray-0' },
		}}
	>
		Message us
	</LinkButton>
</Tooltip>
